export default __webpack_public_path__ + "static/img-perk-6-805e8d1aaab655d6f7aa00b668ae22e1.png";